window.addEventListener('load', function () {
    const filterField = document.querySelector('.xo-field-checkbox__input[xo-label="Proteine"]');
    const submenu = document.querySelector('.filters-submenu');
  
    const toggleSubmenu = () => {
      if (filterField.checked) {
        filterField.setAttribute('checked', '');
        submenu.style.display = 'block';
        submenu.style.maxHeight = "none";
      } else {
        filterField.removeAttribute('checked', '');
        submenu.style.display = 'none';
        submenu.style.maxHeight = "0px";
      }
    };

    toggleSubmenu();

    filterField.addEventListener('change', toggleSubmenu);
  });
